module.exports = __webpack_public_path__ + "img/horizontal_4_7_pp2_5012.8a3780bf.png";